// extracted by mini-css-extract-plugin
export default {"wrapper":"FechaSelector_wrapper__vBgIB"};